// Enums
import { EmailValidationStatus } from '../../enums';

// Models
import { CustomerOptions } from '../CustomerOptions/CustomerOptions';
import { RegularExpressions } from '../RegularExpressions/RegularExpressions';
import { UserRights } from '../UserRights/UserRights';

export class AuthUser {
    id: string;
    applicationName: string;
    isActive: boolean;
    displayName: string;
    type: string;
    email: string;
    greetingName: string;
    employerId: string;
    employerName: string;
    clientId: string;
    clientName: string;
    clientActive: boolean;
    dbaName: string;
    divisionId: string;
    divisionName: string;
    divisionActive: boolean;
    groupId: string;
    groupName: string;
    groupActive: boolean;
    entityTypeName: string;
    entityId: string;
    portalTimeout: number;
    emailValidationStatus: EmailValidationStatus;
    roles: string[];
    rights: UserRights;
    customerOptions: CustomerOptions;
    planId: string;
    divisionPlanId: string;
    individualPlanId: string;
    isAuthorized: boolean;
    unAuthorizedReason: string;
    isImageLoading: boolean;
    employerLogo: string;
    isLogged: boolean;
    regularExpressions: RegularExpressions;

    constructor() {
      this.isImageLoading = true;
      this.regularExpressions = null;
    }
}
